"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CLIENT_STORAGE_LOCAL_STORAGE", {
  enumerable: true,
  get: function get() {
    return _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE;
  }
});
Object.defineProperty(exports, "CLIENT_STORAGE_COOKIES", {
  enumerable: true,
  get: function get() {
    return _clientStorage.CLIENT_STORAGE_COOKIES;
  }
});
Object.defineProperty(exports, "CLIENT_STORAGE_ALL", {
  enumerable: true,
  get: function get() {
    return _clientStorage.CLIENT_STORAGE_ALL;
  }
});
Object.defineProperty(exports, "getItem", {
  enumerable: true,
  get: function get() {
    return _getItem.default;
  }
});
Object.defineProperty(exports, "setItem", {
  enumerable: true,
  get: function get() {
    return _setItem.default;
  }
});
Object.defineProperty(exports, "removeItem", {
  enumerable: true,
  get: function get() {
    return _removeItem.default;
  }
});
Object.defineProperty(exports, "parseItem", {
  enumerable: true,
  get: function get() {
    return _parseItem.default;
  }
});

var _clientStorage = require("../../constants/clientStorage");

var _getItem = _interopRequireDefault(require("./getItem"));

var _setItem = _interopRequireDefault(require("./setItem"));

var _removeItem = _interopRequireDefault(require("./removeItem"));

var _parseItem = _interopRequireDefault(require("./parseItem"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}